/**
 * Gemini Model Configuration — Client-Side
 *
 * Subset of the server config for UI dropdowns and model references.
 * Keep PRO/FLASH/LITE in sync with functions-ai/src/config/gemini-models.ts.
 *
 * PINNED TO GA — do not reintroduce "-latest" aliases (see the server config
 * header for why). Values must match the server so a model selected in the UI
 * resolves to the same GA model the backend calls.
 *
 * 2026-08-05 fleet upgrade: 2.5 family -> GA 3.x. REASONING + FLASH both pin to
 * 3.6 Flash; LITE moves to gemini-3.5-flash-lite (no GA 3.x Pro exists yet).
 *
 * 2026-08-16: FLASH + PRO bumped 3.6 Flash -> gemini-3.7-flash to match the
 * server config. Re-verified GA on BOTH backends (Vertex AI global + Genkit googleAI,
 * verify-gemini-models.ts all [+]). LITE unchanged.
 */

export const GEMINI_MODELS = {
  PRO: "gemini-3.8-flash",
  FLASH: "gemini-3.8-flash",
  LITE: "gemini-3.5-flash-lite",
} as const;

export const AVAILABLE_MODELS = [
  { value: GEMINI_MODELS.LITE, label: "Gemini 3.5 Flash Lite" },
  { value: GEMINI_MODELS.FLASH, label: "Gemini 3.8 Flash" },
  { value: GEMINI_MODELS.PRO, label: "Gemini 3.8 Flash (Reasoning)" },
] as const;
